import { useState, useEffect } from 'react';
import TokenService from '@/services/service.token';

const useWebSocketConnection = () => {
  const [socket, setSocket] = useState<WebSocket | null>(null);
  const [isSocketReady, setIsSocketReady] = useState(false);

  useEffect(() => {
    const token = TokenService.getToken()?.access;
    if (!token) {
      return;
    }

    const newSocket = new WebSocket(`wss://api.kurtasari.com/v1/ws/notifications/?token=${token}`);

    newSocket.onopen = () => {
      setIsSocketReady(true);
    };

    newSocket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    newSocket.onclose = () => {
      setIsSocketReady(false);
    };

    setSocket(newSocket);
  }, []);

  return { socket, isSocketReady };
};

export default useWebSocketConnection;
